module.exports = __webpack_public_path__ + "img/empty.22e7654d.png";